import { useEffect, useState } from "react";
import { Alert, Button, Form, FormGroup, Input, Modal } from "reactstrap";
import AppSpinner from "../../elements/AppSpinner";

/**
 * Simple modal allowing user to input one thing
 *
 * @param {boolean} open - Boolean whether or not modal should be open.
 * @param {function} onClose - Function that is called when the modal is closed
 * @param {string=} inputTitle - Title above of the input
 * @param {string=} inputType - The type for the input
 * @param {string=} inputPlaceholder - The placeholder for the input
 * @param {string=} cancelButtonText - The text for the cancel button
 * @param {string=} confirmButtonText - The text for the confirm button
 * @param {function} onConfirm - Function that is called when confirm button is clicked
 * @param {boolean=} submitting - Boolean containing submission state, changes confirm button to spinner when true
 */
const SingleInputModal = ({
  open,
  onClose,
  title,
  inputTitle = "",
  inputType = "text",
  inputPlaceholder = "",
  cancelButtonText = "Cancel",
  confirmButtonText = "Confirm",
  existingValue = null,
  onConfirm,
  submitting = false,
  error,
}) => {
  const [value, setValue] = useState("");
  const handleChange = (e) => setValue(e.target.value);

  const handleClose = () => {
    setValue(existingValue || "");
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(value, () => {
      handleClose();
    });
  };

  // Sync value with existingValue
  useEffect(() => {
    if (existingValue) {
      setValue(existingValue);
    }
  }, [existingValue]);

  return (
    <Modal className="modal-dialog-centered" isOpen={open} toggle={handleClose}>
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          {title}
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <Form onSubmit={handleSubmit}>
        <div className="modal-body pb-2">
          <FormGroup>
            <h5>{inputTitle}</h5>
            <Input
              placeholder={inputPlaceholder}
              type={inputType}
              required={true}
              value={value}
              onChange={handleChange}
            />
            {error && (
              <Alert className="mt-2" color="danger">
                {error}
              </Alert>
            )}
          </FormGroup>
        </div>
        <div className="modal-footer pt-2">
          <Button
            color="secondary"
            data-dismiss="modal"
            type="button"
            onClick={handleClose}
          >
            {cancelButtonText}
          </Button>
          <Button color="primary" type="submit" disabled={submitting || !value}>
            {submitting ? <AppSpinner color="white" /> : confirmButtonText}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default SingleInputModal;
